import DocumentationButton from "components/DocumentationButton";
import {
  EmptystateCodeBrowserColored,
  EmptystateSearchNoResultsColored,
} from "components/icons/generated";
import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import EmptyState from "ds/components/EmptyState";
import useCanCreateTemplate from "shared/Templates/access/useCanCreateTemplate";
import { getDocsUrl } from "utils/getDocsUrl";

type TemplatesMarketplaceEmptyProps = {
  hasNoResults?: boolean;
};

const TemplatesMarketplaceEmpty = ({ hasNoResults }: TemplatesMarketplaceEmptyProps) => {
  const canCreateTemplate = useCanCreateTemplate();
  return (
    <>
      {hasNoResults && (
        <EmptyState
          title="No results"
          caption="Try different filters."
          icon={EmptystateSearchNoResultsColored}
          announce
        />
      )}

      {!hasNoResults && (
        <EmptyState
          title="No templates available yet"
          icon={EmptystateCodeBrowserColored}
          caption="Templates are ready-to-use infrastructure configurations. When templates are published, they will be available here"
        >
          <Box gap="medium">
            <DocumentationButton
              to={getDocsUrl("/concepts/template/deployments")}
              label="Learn more"
            />

            {canCreateTemplate.result && (
              <LinkButton to="/templates-workbench" variant="primary">
                Create Template
              </LinkButton>
            )}
          </Box>
        </EmptyState>
      )}
    </>
  );
};

export default TemplatesMarketplaceEmpty;
